import React from 'react';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'The Audit',
    description: 'Use the worksheets to identify why the "walls" went up in your specific family.'
  }, {
    number: '2',
    title: 'The Script',
    description: 'Choose one "Low-Stakes" message from the library and customize it using the E.A.S.E. Framework.'
  }, {
    number: '3',
    title: 'The Reset',
    description: 'Follow the 7-Minute sequence to stay calm while you wait for a response, protecting your own peace.'
  }];
  return <section className="py-20 bg-brand-sage relative overflow-hidden" data-id="element-69">
      {/* Decorative leaf-like shape */}
      <div className="absolute -right-20 top-10 w-64 h-64 bg-brand-cream rounded-full opacity-40 blur-2xl" data-id="element-70"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-71">
        <div className="text-center mb-16" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-73">How It Works</h2>
          <p className="text-lg text-brand-body max-w-2xl mx-auto" data-id="element-74">
            A gentle, step-by-step process designed to protect your heart while
            opening the door.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-75">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-brand-gold/30 z-0" data-id="element-76"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-77">
              <div className="w-24 h-24 rounded-full bg-brand-cream border-4 border-brand-sage shadow-sm flex items-center justify-center mb-6" data-id="element-78">
                <span className="font-heading text-3xl font-bold text-brand-gold" data-id="element-79">
                  {step.number}
                </span>
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-80">{step.title}</h3>
              <p className="text-brand-body leading-relaxed px-4" data-id="element-81">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}